import { channelInfo, dealwithChannelChartKey } from '@op/components/ChannelLabel';
import { formatChartParamsDate, listTimeTitleFunc } from '@op/components/ChartCommon/formatter';
import EChartCommon from '@op/components/EChartCommon';
import { NO_DATE } from '@op/constants';
import useLanguage from '@op/hooks/useLanguage';
import { echartsContent } from '@op/utils';
import { getXAxisAxisLabel } from '@op/utils/chart';
import { DBO_EC, DBO_V, DBO_Y } from '@op/utils/format';
import { dealWithOthersName } from '@op/utils/languageValue';
import { reviewsFormat } from '@op/utils/value';
import React, { useMemo } from 'react';

interface IRealtimeChannelLanguageChart {
  chartType: string;
  title: string;
  data: any;
  formatValue?: (value: string | number) => string | number;
  formatDate?: (val: string) => string;
  type: 'channel' | 'language';
  metrics: string;
  isPercent?: boolean;
  filter: any;
}
export default function Chart(props: IRealtimeChannelLanguageChart) {
  const { chartType, title, data, type, metrics, isPercent = false, formatValue = reviewsFormat, filter } = props;
  const { formatMessage } = useLanguage();
  const chartRealType = useMemo(() => {
    return chartType === 'stack_line' ? 'line' : chartType;
  }, [chartType]);


  const options = useMemo(() => {
    const { seriesData, legendData, xAxisData } = data || {};
    const selectedSeries = seriesData?.[metrics] || [];
    const series = selectedSeries.map((val: { color: string; }) => {
      const { color, data } = val;
      const item = { ...val };
      if (['bar', 'stack_line'].includes(chartType)) {
        item.stack = 'Total';
        if (chartType === 'stack_line') {
          item.areaStyle = DBO_EC.gradientColor(color, 0, 0.4);
        }
      }
      return {
        ...item,
        data: data.map((val: any) => val ? val : 0),
        type: chartRealType,
      };
    });

    return {
      series,
      legend: {
        data: legendData,
        formatter: (params: any) => {
          if (type === 'channel' && params !== 'Others') {
            const { name } = channelInfo(params);
            return `{${dealwithChannelChartKey(params)}|} {name| ${name}}`;
          }
          return dealWithOthersName(params, type);
        },
      },
      tooltip: {
        className: 'dbo-mentions-sentiment-box-tooltip-wrapper',
        formatter: (params: any) => {
          const leftTitle = listTimeTitleFunc(params[0]?.axisValue, filter?.date_type || 'hourly');
          const rightTitle = formatMessage({
            id: title || NO_DATE.EMPTY,
          });
          return formatChartParamsDate({
            title: leftTitle,
            rightTitle,
            params,
            isSort: true,
            listTitleFunc: (item: any) => {
              const isNoOther = item.seriesName !== 'Others';
              if (type === 'channel') {
                const { img, name } = channelInfo(item.seriesName);
                return `<span class="dbo-chart-formatter-img"><img src=${img} class="chart-common-formatter-img" /> ${isNoOther ? name : formatMessage({ id: 'Others' })}<span>`;
              }
              return dealWithOthersName(item.seriesName, type);
            },
            valueFormat(value) {
              return formatValue(value);
            },
            dealwithRecords: (records, total) => {
              const list = records.map((item) => {
                if (item.originValue === 0) return item;

                if (isPercent) return item;

                return {
                  ...item,
                  value: `${item.value}`,
                };
              });

              // if (!isPercent) {
              //   list.unshift({
              //     text: formatMessage({ id: title || NO_DATE.EMPTY }),
              //     value: formatValue(total) as any,
              //     originValue: total,
              //     originText: title as any,
              //   });
              // }
              return list;
            },
          });
        },
      },
      xAxis: {
        axisLabel: getXAxisAxisLabel(filter),
        data: xAxisData || [],
      },
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: (value: any) => {
              return DBO_Y.reviewsPercent(value, isPercent);
            },
            color: '#838697',
          },
          nameTextStyle: {
            color: '#444444',
            fontWeight: 400,
            fontSize: '12px',
          },
          splitNumber: 5,
        },
        {
          type: 'value',
          axisLabel: {
            formatter: (value: any) => echartsContent(value),
            color: '#838697',
          },
        },
      ],
    };
  }, [chartType, data]);

  return (
    <EChartCommon
      optionsProps={{ type: chartRealType }}
      height={338}
      leftTitle={formatMessage({ id: title || NO_DATE.EMPTY })}
      options={options}
    ></EChartCommon>
  );
}